__webpack_require__.p = "/games/divdraw/";